import {range} from '@benchling/js-utils';
import React from 'react';

import {Sequence} from 'components/Sequence';
import {Selection} from 'molbio/maps/selectables/Selection';
import {getStore} from 'redux-stores/Store';
import * as LegacyModalContainer from 'ui-library/LegacyModalContainer';

import {MissingMonomerReason} from './MonomerConstants';
import NucleotidesEditModal, {QueryingNucleotidesEditModal} from './NucleotidesEditModal';
import {
  clearNucleotideRowSelection,
  pageNucleotideRowIntoView,
  selectNucleotideRows,
} from './NucleotidesUIReduxActions';

export function handleEditFromSelection(sequence: Sequence, selection: Selection): void {
  const selectedPositions = range(selection.start(), selection.end()! - 1);

  getStore().dispatch(clearNucleotideRowSelection(sequence.id));
  getStore().dispatch(pageNucleotideRowIntoView(sequence.id, sequence.selection().start()));
  getStore().dispatch(selectNucleotideRows(sequence.id, selectedPositions));

  LegacyModalContainer.open(
    NucleotidesEditModal,
    <QueryingNucleotidesEditModal
      initialSugarId={MissingMonomerReason.CHOOSING}
      initialBaseId={MissingMonomerReason.CHOOSING}
      initialPhosphateId={MissingMonomerReason.CHOOSING}
      positions={new Set(selectedPositions)}
      nucleotideType={sequence.nucleotideType()}
      onSubmit={(params) => {
        sequence.bulkSetMods({rules: [params]});
        getStore().dispatch(clearNucleotideRowSelection(sequence.id));
      }}
      onClose={() => {
        getStore().dispatch(clearNucleotideRowSelection(sequence.id));
      }}
      sequenceId={sequence.get('id')}
    />
  );
}
